import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IGroupSpace } from "../../group-spaces/types";
import { IGroupTaskResource } from "../../group-tasks";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValueAsIRI } from "../../utils/filters";

export type IGroupTaskCreateMutationParameters = {
    uuid?: string;
    groupSpace: RelationalValue<IGroupSpace>;
    title: string;
    description?: string;
};

export type IGroupTaskCreateMutationResult = IGroupTaskResource;

export const groupTaskCreateMutation: IApiMutationFunction<IGroupTaskCreateMutationParameters> = ({
    groupSpace,
    title,
    description,
    uuid: providedUuid,
}) => {
    return {
        method: "POST",
        url: "/group_tasks",
        data: {
            uuid: providedUuid ?? uuid(),
            groupSpace: mapRelationalValueAsIRI(EntityTypes.GROUP_SPACE, groupSpace),
            title,
            description,
        },
    };
};

export const useGroupTaskCreateMutation = createApiMutationHook<
    IGroupTaskCreateMutationParameters,
    IGroupTaskCreateMutationResult
>(groupTaskCreateMutation);
